import { EditableDateField } from 'components/EditableDateField/EditableDateField';
import { useEffect, useState } from 'react';
import { useEditCommittedPaymentDateForOrder } from './hooks/useEditCommittedPaymentDateForOrder';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { useEditCommittedPaymentDateForLogisticService } from './hooks/useEditCommittedPaymentDateForLogisticService';

interface ICommittedPaymentEditor {
  id?: number;
  committedPaymentDate?: string;
  logisticService?: boolean;
  onChange?: (newDate: string) => void;
}

export const CommittedPaymentEditor = ({
  id,
  committedPaymentDate,
  logisticService,
  onChange
}: ICommittedPaymentEditor) => {
  const [date, setDate] = useState<string>();

  const committedPaymentDateForLogisticService = useEditCommittedPaymentDateForLogisticService();
  const committedPaymentDateForOrder = useEditCommittedPaymentDateForOrder();

  const { isLoading, editDate } = logisticService
    ? committedPaymentDateForLogisticService
    : committedPaymentDateForOrder;

  const editCommittedPaymentDate = async (date: string) => {
    try {
      if (!date || !id) return;

      const isSuccessful = await editDate(id, date);
      setDate(date);
      if (isSuccessful) onChange?.(date);
    } catch (error) {
      displayErrorNotification();
    }
  };

  const updateCommittedPaymentDate = (committedPaymentDate?: string) => {
    if (!committedPaymentDate) return;
    setDate(committedPaymentDate);
  };

  useEffect(() => {
    updateCommittedPaymentDate(committedPaymentDate);
  }, [committedPaymentDate]);

  return <EditableDateField disabled={isLoading} value={date} onChange={editCommittedPaymentDate} />;
};
